import {
	type ConfigSidebarSection,
	type ConfigurationsType,
	useHasPermission,
} from "@dexteel/mesf-core";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStatsOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import ViewQuiltOutlinedIcon from "@mui/icons-material/ViewQuiltOutlined";
import WarehouseOutlinedIcon from "@mui/icons-material/WarehouseOutlined";
import CraftsPage, { CRAFTS_PERMISSION } from "./configurations/crafts";
import EmailRecipientsPage from "./configurations/email-recipients";
import FormsPage from "./configurations/forms";
import ProductionStatisticsPage from "./configurations/production-statistics";
import ShelvesPage from "./configurations/shelves";
import StatisticsPage from "./configurations/statistics";
import TaskListAreasPage from "./configurations/task-list-areas";

const components = [
	{
		path: "task-list-areas",
		sidebar: () => <div>Task List Areas</div>,
		main: () => <TaskListAreasPage />,
	},
	{
		path: "crafts",
		sidebar: () => <div>Crafts</div>,
		main: () => <CraftsPage />,
	},
	{
		path: "forms",
		sidebar: () => <div>Forms</div>,
		main: () => <FormsPage />,
	},
	{
		path: "shelves",
		sidebar: () => <div>Shelves</div>,
		main: () => <ShelvesPage />,
	},
	{
		path: "statistics",
		sidebar: () => <div>Statistics</div>,
		main: () => <StatisticsPage />,
	},
	{
		path: "production-statistics",
		sidebar: () => <div>System Activity</div>,
		main: () => <ProductionStatisticsPage />,
	},
	{
		path: "email-recipients",
		sidebar: () => <div>Email Recipients</div>,
		main: () => <EmailRecipientsPage />,
	},
];

// Handed to mesf-core as data so the menu draws them with its own section style
const sidebarSections: ConfigSidebarSection[] = [
	{
		name: "Task List",
		icon: <ChecklistOutlinedIcon />,
		items: [
			{
				path: "task-list-areas",
				label: "Areas",
				icon: <ViewQuiltOutlinedIcon />,
			},
		],
	},
	{
		name: "Work Orders",
		icon: <BuildOutlinedIcon />,
		items: [
			{
				path: "crafts",
				label: "Crafts",
				icon: <ConstructionOutlinedIcon />,
			},
		],
	},
	{
		name: "Forms",
		icon: <DescriptionOutlinedIcon />,
		items: [
			{
				path: "forms",
				label: "Forms",
				icon: <AssignmentOutlinedIcon />,
			},
		],
	},
	{
		name: "Documents",
		icon: <FolderOutlinedIcon />,
		items: [
			{
				path: "shelves",
				label: "Shelves",
				icon: <WarehouseOutlinedIcon />,
			},
		],
	},
	{
		name: "Statistics",
		icon: <QueryStatsOutlinedIcon />,
		items: [
			{
				path: "statistics",
				label: "System Usage",
				icon: <BarChartOutlinedIcon />,
			},
			{
				path: "production-statistics",
				label: "System Activity",
				icon: <TrendingUpOutlinedIcon />,
			},
		],
	},
	{
		name: "Emails",
		icon: <MailOutlinedIcon />,
		items: [
			{
				path: "email-recipients",
				label: "Email Recipients",
				icon: <ContactMailOutlinedIcon />,
			},
		],
	},
];

const itemPermissions: Record<string, string> = {
	crafts: CRAFTS_PERMISSION,
};

const useSidebarSections = (): ConfigSidebarSection[] => {
	const hasPermissionTo = useHasPermission();

	return sidebarSections
		.map((section) => ({
			...section,
			items: section.items.filter((item) => {
				const permission = itemPermissions[item.path];
				return !permission || hasPermissionTo(permission);
			}),
		}))
		.filter((section) => section.items.length > 0);
};

const customConfigurations: ConfigurationsType = [
	components,
	null,
	useSidebarSections,
];

export { customConfigurations };
